<script lang="ts">
	import { Heading, P } from 'flowbite-svelte';

	export let title: string;
	export let description: string = '';
</script>

<div class="mb-6">
	<Heading tag="h1" class="text-2xl font-bold text-gray-900 dark:text-white">
		{title}
	</Heading>
	{#if description}
		<P class="mt-1 text-gray-500 dark:text-gray-400">
			{description}
		</P>
	{/if}
</div>
